export interface AccessStep {
  text: string
  emphasis?: string
}

export const accessSteps: AccessStep[] = [
  {
    text: 'Cliquez sur le bouton vert ci-dessous pour ouvrir votre dossier Google Drive.',
  },
  {
    text: 'Téléchargez et enregistrez les 6 volumes et les bonus sur votre ordinateur ou votre téléphone.',
  },
  {
    emphasis: 'Important :',
    text: 'téléchargez votre contenu dès maintenant. Dans la journée, nous vous enverrons également ce même accès par e-mail (pensez à vérifier le dossier spam), en sauvegarde.',
  },
]

export const downloadUrl =
  'https://drive.google.com/drive/folders/1P_4j94XH_eLVTkX-GCDZc33FkzL53SUI?usp=sharing'

export const supportEmail = 'soporte.recursopack@gmail.com'

export const productImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/46828e49-2980-4165-b70a-048c107e0bd7.jpg'
